import React from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import Login from "./views/Login/Login";
import Dashboard from "./views/Dashboard/Dashboard";
import Report from "./views/Reports/Report";
import { ROUTES } from "./constants";
import ThemeToggle from "./components/ThemeToggle/ThemeToggle";
import { Box } from "@mui/material";
import AllAccounts from "./views/manageAccount/AllAccounts/AllAccounts";
import MainLayout from "./components/Layout/MainLayout";
import AllProjects from "./views/Project/ProjectAll/AllProjects.js";
import AllResources from "./views/Resource/ResourceAll/AllResources";
import AllRoles from "./views/Admin/Roles/AllRoles";
import AllRolesCategory from "./views/Admin/RolesCategory/AllRolesCategory";
import SkillCategoryLanding from "./views/SkillCategory/SkillCategoryLanding.js";
import BusinessUnits from "./views/BusinessUnit/BusinessUnits/BusinessUnits";
import SkillLanding from "./views/Skill/SkillLanding.js";
import AllCountries from "./views/ManageCountry/AllCountries.js";
import ClientIndustries from "./views/ClientIndustry/ClientIndustries/ClientIndustries.js";
import AllProjectResourceMappings from "./views/ProjectResourceMapping/ProjectResourceMappingAll/AllProjectResourceMappings.js";
import CityLanding from "./views/City/CityLanding.js";
import ClientDesignations from "./views/ClientDesignation/ClientDesignations/ClientDesignations.js";
import AllResourceSkills from "./views/ManageSkills/AllResourceSkills.js";
import { useRbac } from "./hooks/RbacContext";
import AllClientPocs from "./views/ManageClientPoc/AllClientPocs.js";
import Unauthorized from "./components/Unauthorized/Unauthorized";
import Logs from "./views/logs/Logs";
import AllProjectMilestones from "./views/ProjectMilestone/ProjectMilestoneAll/AllProjectMilestone.js";
import ProjectDetails from "./views/Project/ProjectDetails/ProjectDetails.js";
import TimesheetDetails from "./views/timesheet/TimesheetDetails";
import { ExtractReport } from "./views/Reports/ExtractReport.js";
import PageNotFound from "./components/PageNotFound/PageNotFound.js";
import AllTags from "./views/ManageTag/AllTags.js";
import ActivityTagLanding from "./views/ManageActivity/ActivityTagLanding.js";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  if (!isLoggedIn) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  return children;
};

const PrivateLayout = ({ children }) => {
  return (
    <MainLayout>
      {children}
      {/* <Box sx={{ position: "fixed", top: 16, right: 16, zIndex: 1200 }}>
        <ThemeToggle />
      </Box> */}
    </MainLayout>
  );
};

const PublicLayout = ({ children }) => {
  return (
    <Box sx={{ height: "100vh", position: "relative" }}>
      <Box sx={{ position: "absolute", top: 16, right: 16, zIndex: 1 }}>
        {/* <ThemeToggle /> */}
      </Box>
      {children}
    </Box>
  );
};

const ProjectDetailsWrapper = () => {
  const { id } = useParams();
  const { ProtectedRoute } = useRbac();

  return (
    <ProtectedRoute projectId={parseInt(id)}>
      <ProjectDetails />
    </ProtectedRoute>
  );
};

const AppRoutes = () => {
  const { isLoggedIn } = useAuth();
  const {
    ProtectedRoute,
    loading: rbacLoading,
    permissions,
    hasModuleAccess,
  } = useRbac();
  const hasProjectAccess = hasModuleAccess("projects");
  if (isLoggedIn && rbacLoading && !permissions) {
    return <div>Loading permissions...</div>;
  }
  return (
    <Routes>
      <Route
        path={ROUTES.LOGIN}
        element={
          // isLoggedIn ? (
          //   hasProjectAccess ? (
          //     <Navigate to={ROUTES.PROJECT} replace />
          //   ) : (
          //     <Navigate to={ROUTES.TIMESHEET} replace />
          //   )
          // ) : (
          //   <PublicLayout>
          //     <Login />
          //   </PublicLayout>
          // )
          isLoggedIn && permissions?.globalRole?.role_id ? (
            permissions?.globalRole?.role_id === 13 ? (
              <Navigate to={ROUTES.TIMESHEET} replace />
            ) : (
              <Navigate to={ROUTES.PROJECT} replace />
            )
          ) : (
            <PublicLayout>
              <Login />
            </PublicLayout>
          )
        }
      />

      {/* <Route
        path={ROUTES.DASHBOARD}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <Dashboard />
            </PrivateLayout>
          </PrivateRoute>
        }
      /> */}

      <Route
        path={ROUTES.REPORTS}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="reports">
                <ExtractReport />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.BUSINESS_UNIT}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="businessUnit">
                <BusinessUnits />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.CLIENT_INDUSTRIES}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="clientIndustry">
                <ClientIndustries />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.TAGS}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="tag">
                <ActivityTagLanding />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.CLIENT_DESIGNATIONS}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="clientDesignation">
                <ClientDesignations />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.RESOURCE_SKILLS}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="resourceSkillMapping">
                <AllResourceSkills />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.CLIENT}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="client">
                <AllAccounts />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.ADMINISTRATION.SKILL_CATEGORY}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="skillCategory">
                <SkillCategoryLanding />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.ADMINISTRATION.SKILL}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="skill">
                <SkillLanding />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.PROJECT}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="projects">
                <AllProjects />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.RESOURCE}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="resource">
                <AllResources />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.COUNTRY}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="country">
                <AllCountries />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.ADMINISTRATION.CITY}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="city">
                <CityLanding />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.SUPPORT.USER_GUIDE}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <div>User Guide (Coming Soon)</div>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.SUPPORT.IT_SUPPORT}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <div>IT Support (Coming Soon)</div>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.ROLES}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="role">
                <AllRoles />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.ROLES_CATEGORIES}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="roleCategory">
                <AllRolesCategory />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={ROUTES.CLIENT_POCS}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="clientPOC">
                <AllClientPocs />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      {/*Project resource mapping*/}
      <Route
        path={ROUTES.PROJECT_MANAGE.PROJECT_RESOURCE_MAPPING}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="projectsResourceMapping">
                <AllProjectResourceMappings />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={ROUTES.PROJECT_MANAGE.PROJECT_MILESTONE}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="milestones">
                <AllProjectMilestones />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.ACTIVITY_LOGS}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="logs">
                <Logs />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.UNAUTHORIZED}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <Unauthorized />
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.PROJECT_DETAILS}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProjectDetailsWrapper />
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.TIMESHEET}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="Timesheet">
                <TimesheetDetails />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.ANALYTICS_DASHBOARD}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <ProtectedRoute module="analytics">
                <Report />
              </ProtectedRoute>
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={ROUTES.PAGE_NOT_FOUND}
        element={
          <PrivateRoute>
            <PrivateLayout>
              <PageNotFound />
            </PrivateLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="*"
        element={
          isLoggedIn ? (
            <Navigate to={ROUTES.PAGE_NOT_FOUND} replace />
          ) : (
            <Navigate to={ROUTES.LOGIN} replace />
          )
        }
      />

      <Route
        path="/"
        element={
          isLoggedIn ? (
            permissions?.globalRole?.role_id === 13 ? (
              <Navigate to={ROUTES.TIMESHEET} replace />
            ) : (
              <Navigate to={ROUTES.PROJECT} replace />
            )
          ) : (
            <Navigate to={ROUTES.LOGIN} replace />
          )
        }
      />
    </Routes>
  );
};

export default AppRoutes;
